/*
 * ProArt Card Hover Effects
 * 5 simultaneous effects: 3D tilt, spotlight, parallax, glitch, scan line
 */
(function() {
  'use strict';

  /* ---- SMALL CARDS ---- */
  document.querySelectorAll('.proart-card--small').forEach(function(card) {

    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left - rect.width / 2) / rect.width;
      var y = (e.clientY - rect.top - rect.height / 2) / rect.height;
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;

      /* 1. 3D TILT */
      card.style.transform = 'translateY(-8px) rotateX(' + (-y * 8) + 'deg) rotateY(' + (x * 8) + 'deg) scale(1.02)';
      card.style.transition = 'transform 0.15s ease';

      /* 2. SPOTLIGHT follows cursor */
      var spot = card.querySelector('.proart-card__spotlight');
      if (spot) {
        spot.style.background = 'radial-gradient(circle 200px at ' + xPct + '% ' + yPct + '%, rgba(201,168,76,0.12) 0%, transparent 70%)';
        spot.style.opacity = '1';
      }

      /* 3. IMAGE PARALLAX */
      var img = card.querySelector('.proart-card__img, .proart-card__placeholder');
      if (img) {
        img.style.transform = 'scale(1.08) translate(' + (x * -12) + 'px,' + (y * -12) + 'px)';
        img.style.transition = 'transform 0.3s ease';
      }

      /* 4. TITLE GLITCH — rare */
      if (Math.random() > 0.95) {
        var title = card.querySelector('h3');
        if (title) {
          title.style.textShadow = (Math.random() * 4 - 2) + 'px 0 rgba(201,168,76,0.6), ' + (Math.random() * -4 + 2) + 'px 0 rgba(255,255,255,0.3)';
          setTimeout(function() { title.style.textShadow = 'none'; }, 80);
        }
      }
    });

    card.addEventListener('mouseleave', function() {
      card.style.transform = 'translateY(0) rotateX(0) rotateY(0) scale(1)';
      card.style.transition = 'transform 0.6s cubic-bezier(0.16,1,0.3,1)';

      var spot = card.querySelector('.proart-card__spotlight');
      if (spot) spot.style.opacity = '0';

      var img = card.querySelector('.proart-card__img, .proart-card__placeholder');
      if (img) {
        img.style.transform = 'scale(1) translate(0,0)';
        img.style.transition = 'transform 0.6s ease';
      }
    });

    /* 5. CLICK RIPPLE */
    card.addEventListener('click', function(e) {
      var rect = card.getBoundingClientRect();
      var ripple = document.createElement('div');
      ripple.className = 'proart-card__ripple';
      ripple.style.left = (e.clientX - rect.left - 5) + 'px';
      ripple.style.top = (e.clientY - rect.top - 5) + 'px';
      card.appendChild(ripple);
      setTimeout(function() { ripple.remove(); }, 600);
    });
  });

  /* ---- FEATURED CARD ---- */
  document.querySelectorAll('.proart-card--featured').forEach(function(card) {

    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left - rect.width / 2) / rect.width;
      var y = (e.clientY - rect.top - rect.height / 2) / rect.height;
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;

      card.style.transform = 'rotateX(' + (-y * 4) + 'deg) rotateY(' + (x * 4) + 'deg)';
      card.style.transition = 'transform 0.2s ease';

      var spot = card.querySelector('.proart-card__spotlight');
      if (spot) {
        spot.style.background = 'radial-gradient(circle 350px at ' + xPct + '% ' + yPct + '%, rgba(201,168,76,0.1) 0%, transparent 70%)';
        spot.style.opacity = '1';
      }

      /* Rings speed up */
      var rings = card.querySelectorAll('.proart-card__ring');
      rings.forEach(function(r) {
        r.style.animationDuration = '4s';
        r.style.borderColor = 'rgba(201,168,76,0.3)';
      });

      /* Image parallax */
      var img = card.querySelector('.proart-card__featured-img');
      if (img) {
        img.style.transform = 'scale(1.06) translate(' + (x * -10) + 'px,' + (y * -10) + 'px)';
        img.style.transition = 'transform 0.3s ease';
      }
    });

    card.addEventListener('mouseleave', function() {
      card.style.transform = 'rotateX(0) rotateY(0)';
      card.style.transition = 'transform 0.8s cubic-bezier(0.16,1,0.3,1)';

      var spot = card.querySelector('.proart-card__spotlight');
      if (spot) spot.style.opacity = '0';

      var rings = card.querySelectorAll('.proart-card__ring');
      rings.forEach(function(r) {
        r.style.animationDuration = '';
        r.style.borderColor = '';
      });

      var img = card.querySelector('.proart-card__featured-img');
      if (img) {
        img.style.transform = 'scale(1) translate(0,0)';
        img.style.transition = 'transform 0.6s ease';
      }
    });
  });
})();
